const config = {
    baseUrl: '',
    // baseUrl: 'https://ratemyadjuster.com',
    // baseUrl: 'http://localhost:3000',
    projectName: "Rate My Adjuster"
}
export default config;